export default __webpack_public_path__ + "static/media/ap_gradient_button.e9de6835.png";